module.exports = __webpack_public_path__ + "img/newspaper.288587a6.svg";